import enLabels from "react-phone-number-input/locale/en";

/**
 * Country labels for <PhoneInput>. The library ships no Romanian locale, so we
 * override the countries our users actually search for (Romania + the main
 * diaspora destinations); the long tail stays in English and is still findable
 * by dial code.
 *
 * Shared between the demo-request modal and the webinar registration form so
 * the two country pickers cannot drift apart.
 */
export const PHONE_LABELS = {
  ...enLabels,
  RO: "România",
  MD: "Moldova",
  GB: "Regatul Unit (UK)",
  DE: "Germania",
  FR: "Franța",
  IT: "Italia",
  ES: "Spania",
  AT: "Austria",
  BE: "Belgia",
  NL: "Olanda",
  CH: "Elveția",
  IE: "Irlanda",
  SE: "Suedia",
  DK: "Danemarca",
  NO: "Norvegia",
  GR: "Grecia",
  HU: "Ungaria",
  PT: "Portugalia",
  US: "Statele Unite (SUA)",
  CA: "Canada",
};
